var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationMarkRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 1.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15z",
    fill: "#E75B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 12V9M9.333 6h.008",
    stroke: "#fff",
    strokeWidth: 1.149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMzMzMDEgMS40OTk3NkMxMy40NzUxIDEuNDk5NzYgMTYuODMzIDQuODU3NjIgMTYuODMzIDguOTk5NzZDMTYuODMzIDEzLjE0MTkgMTMuNDc1MSAxNi40OTk4IDkuMzMzMDEgMTYuNDk5OEM1LjE5MDg3IDE2LjQ5OTggMS44MzMwMSAxMy4xNDE5IDEuODMzMDEgOC45OTk3NkMxLjgzMzAxIDQuODU3NjIgNS4xOTA4NyAxLjQ5OTc2IDkuMzMzMDEgMS40OTk3NloiIGZpbGw9IiNFNzVCNTUiLz4KPHBhdGggZD0iTTkuMzMzMjUgMTEuOTk5OFY4Ljk5OTc2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuMTQ4NTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4zMzMyNSA1Ljk5OTc2SDkuMzQwODQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4xNDg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgExclamationMarkRed as ReactComponent };